import bgImageEN from '../../images/static/share_background_en.jpg';
import bgImageES from '../../images/static/share_background_es.jpg';

export const generateShareCard = ({ name, image, qr, type, locale = 'en' }, callback) => {
  console;
  const imageSources = {
    card: image,
    bg: locale === 'es' ? bgImageES : bgImageEN,
    qr,
  };

  let images = {};
  let loadedImages = 0;
  let numImages = Object.keys(imageSources).length - 1;
  // get num of sources
  for (const [key, value] of Object.entries(imageSources)) {
    console.log('key, value', key, value);
    if (value) {
      images[key] = new Image();
      images[key].crossOrigin = 'anonymous';
      images[key].src = key == 'qr' ? value : `${value}?${Date.now()}`;
      images[key].onload = () => {
        if (loadedImages >= numImages) {
          generateCard({ name, type }, images, callback);
        } else {
          loadedImages = loadedImages + 1;
        }
      };
    }
  }
};

function wrapText(context, text, x, y, maxWidth, lineHeight) {
  const words = text.split(' ');
  let line = '';
  const lines = [];

  for (const word of words) {
    const testLine = line + (line ? ' ' : '') + word;
    const metrics = context.measureText(testLine);

    if (metrics.width > maxWidth && line) {
      lines.push(line);
      line = word;
    } else {
      line = testLine;
    }
  }
  lines.push(line);

  // Adjust starting y to center all lines vertically
  const totalHeight = lines.length * lineHeight;
  let currentY = y - totalHeight / 2 + lineHeight / 2;

  for (const l of lines) {
    context.fillText(l, x, currentY);
    currentY += lineHeight;
  }
}

const generateCard = ({ name, type }, images, callback) => {
  /*
      Setup the canvas element
    */
  const canvas = document.createElement('canvas');
  canvas.style.position = 'absolute';
  canvas.style.zIndex = '9999999';
  canvas.style.top = 0;
  const dpr = window.devicePixelRatio || 1;
  // Get the size of the canvas in CSS pixels.
  // const rect = canvas.getBoundingClientRect();
  // Give the canvas pixel dimensions of their CSS
  // size * the device pixel ratio.
  canvas.width = 382 * dpr;
  canvas.height = 1024 * dpr;
  const context = canvas.getContext('2d');
  // Scale all drawing operations by the dpr, so you
  // don't have to worry about the difference.
  context.scale(dpr, dpr);

  // Add canvas to the DOM to draw on
  canvas.style.display = 'none';
  document.body.appendChild(canvas);

  /*
      Draw elements
    */
  // add image
  context.drawImage(images.bg, 0, 0);

  // draw the card image
  const x = 40;
  const y = 162;
  const width = 307;
  const height = 307;
  const radius = 30; // Adjust corner radius as needed

  context.save();
  context.beginPath();

  // Top-left corner (rounded)
  context.moveTo(x + radius, y);

  // Top-right corner (rounded)
  context.lineTo(x + width - radius, y);
  context.arcTo(x + width, y, x + width, y + radius, radius);

  // Bottom-right corner (square)
  context.lineTo(x + width, y + height);

  // Bottom-left corner (square)
  context.lineTo(x, y + height);

  // Back to top-left corner (rounded)
  context.lineTo(x, y + radius);
  context.arcTo(x, y, x + radius, y, radius);

  context.closePath();
  context.clip();

  context.drawImage(images.card, 0, 0, 507, 507, x, y, width, height);
  context.restore();

  // draw qr code
  context.drawImage(images.qr, 103, 538, 180, 180);

  // add text
  context.font = '28px sesame-sans-heavy';
  context.fillStyle = 'white';
  context.textAlign = 'center';
  context.textBaseline = 'bottom';

  wrapText(context, name, 193, 445, 300, 30);

  context.font = '28px sesame-sans-bold';
  context.fillStyle = '#189fa7';
  context.textAlign = 'center';
  context.textBaseline = 'middle';

  context.fillText(type, 193, 495);

  // automatically download the image
  canvas.toBlob((blob) => {
    if (!blob) return;

    const pngUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = pngUrl;
    link.download = `${name.toLowerCase().replace(/\s+/g, '-')}-qr-code.png`;
    link.click();
    URL.revokeObjectURL(pngUrl);
  });

  /*
      trigger callback to set base64 to state
    */
  if (callback) {
    callback();
  }

  /*
      Remove canvas when done
    */
  if (canvas.parentNode) {
    canvas.parentNode.removeChild(canvas);
  }
};
